<template>
  <div>
    <NavBreadCrumb class="mb-12 lg:mb-16" />
    <div class="mx-auto max-w-screen-lg px-6 md:px-8">
      <SearchTagInput :title="tag" :tag="tag" sort-priority="Blog" />
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();

const capitaliseSlug = (slug: string) =>
  slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const tag = capitaliseSlug(route.params.slug[0]);

const metaStore = useMetaStore();
metaStore.pageTitle = `${tag} | Blog | Aussie Broadband`;
metaStore.metaTitle = `${tag} | Blog | Aussie Broadband`;
metaStore.metaDescription = `Articles about ${tag} from the Blog`;
</script>
